
    var riot = require('riot')
    //src: starling/src/tags/node-perspectives-panel.html
riot.tag2('node-perspectives-panel',
  '<div class="perspectives-panel-headline"> <div class="perspectives-panel-headline-left-side"> <span class="title">{this.tag && pui.getNodePerspectives(this.tag).length ? \'Add/remove perspectives\' : \'Add to the perspective of...\'}</span> </div> <div class="perspectives-panel-headline-right-side" onclick="{this.openPerspectivesOnboarding}"> <i class="material-icons learn-more">info</i> </div> </div> <div class="search-create-perspective-input-container"> <input onkeydown="{this.checkBlurKey}" ref="newPerspectiveInput" placeholder="{pui.getPerspectives().length ? \'Search or create perspective\' : \'Create perspective\'}" class="input-gray focusable" tabindex="-1" size="1" onfocus="{this.handleFocus}" onkeyup="{this.handleInput}"> </div> <div ref="scrollList" class="scroll-list {this.shouldShowAnnotations ? \'\' : \'hide-annotations\'} {this.isEmptyList() ? \'empty\' : \'\'}"> <node-perspectives-panel-item each="{this.getPerspectives()}"></node-perspectives-panel-item> <div ref="cardListing" class="node-perspectives-panel-card-listing mrgn-b-8" show="{this.getMatchingCardsInMap().length > 0}"> <span class="section-listing-label">Cards in map</span> <div class="node-perspectives-panel-card-list-item node-perspective-card-row node-perspective-card-row-{this.id}" each="{this.getMatchingCardsInMap()}"> <div class="node-perspective-item" onclick="{handleCardInMapClick.bind(parent,this.id)}" ondblclick="{ignoreDblClick}" onmouseenter="{handleSelectionMouseEnter.bind(parent,this.id,\'node\')}" onmouseleave="{handleSelectionMouseLeave.bind(parent,this.id,\'node\')}"> <div class="checkbox"> <input class="checkbox add-box" type="checkbox"> </div> <i class="material-icons perspective-point-icon">visibility</i> <h4 class="new-perspective-card-title-{this.id}" title="{this.getTitle().toString()}">{this.getTitle().toString()}</h4> </div> </div> </div> <div ref="createNewPerspectiveSection" class="node-perspectives-panel-card-listing mrgn-b-8" style="display: none;"> <span class="section-listing-label">Create new perspective</span> <div ref="createNewPerspectiveRow" class="node-perspectives-panel-card-list-item"> <div class="node-perspective-item" onclick="{handleCreateNewPerspective}" ondblclick="{ignoreDblClick}"> <div class="checkbox"> <input class="checkbox add-box" type="checkbox"> </div> <i class="material-icons perspective-point-icon">visibility</i> <h4 ref="newPerspectiveCreateLabel"></h4> </div> </div> </div> </div> <div class="menu-item make-perspective-button" show="{this.showConnectPerspectiveButton()}" onclick="{this.connectPerspectivePoint}"> <i class="material-icons">add_circle_outline</i> Connect to <span class="p-node-title"> <i class="material-icons perspective-point-icon" riot-style="{this.connectedPerspectiveStyle()}">visibility</i> {this.pointNodeTitleAbbrev()}</span> </div> <div class="menu-item remove-perspective-button" show="{this.showRemovePerspectiveButton()}" onclick="{this.disconnectPerspectivePoint}"> <i class="material-icons">clear</i> Disconnect <i class="material-icons perspective-point-icon" riot-style="{this.currentPerspectiveStyle()}">visibility</i> <span class="p-node-title">{this.pointNodeTitleAbbrev()}</span> perspective </div>',
  '',
  'ref="main" riot-style="{this.getStyle()}" onmouseenter="{this.handlePanelMouseEnter}"', function(opts) {
'use strict';

var _this = this;

var _store_instance = require('../store_instance');

var _store_instance2 = _interopRequireDefault(_store_instance);

var _store = require('../store');

var _perspectivesUi = require('lib/perspectives-ui');

var _perspectiveCreationUi = require('lib/perspective-creation-ui');

var _searchUi = require('lib/search-ui');

var _constants = require('lib/constants');

var _delayHandler = require('lib/delay-handler');

var _sharedUtil = require('lib/shared-util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

this.canvas = opts.canvas;
this.operation = opts.operation;
this.canvas.nodePerspectivesPanelTag = this;
this.hidden = true;
this.shouldShowAnnotations = true;
this.newPerspectiveTitle = '';
this.focusedResult = null;
this.isOpen = false;
this.origin = null;
this.getPerspectives = function () {
  var perspectives = _perspectivesUi.pui.getPerspectives();
  // list all perspectives with checked ones first
  // and drop any perspectives that the current node is the pointnode of
  var pList = perspectives.concat().sort(function (a, b) {
    var _a = _this.isChecked(a) ? b.orderIndex : 0;
    var _b = _this.isChecked(b) ? a.orderIndex : 0;

    // rank perspectives with some selected elements after
    // perspectives with all selected elements
    if (_this.isBulkAction) {
      var aBulkStatus = _this.bulkMembershipStatus(a);
      var bBulkStatus = _this.bulkMembershipStatus(b);
      if (aBulkStatus == 'all-members') {
        _a = _a + 10000;
      } else if (aBulkStatus == 'some-members') {
        _a = _a + 1000;
      }
      if (bBulkStatus == 'all-members') {
        _b = _b + 10000;
      } else if (bBulkStatus == 'some-members') {
        _b = _b + 1000;
      }
    }

    return _b - _a;
  });

  if (_this.newPerspectiveTitle.length) {
    var searchRegex = _searchUi.searchUI.getSearchRegex(_this.newPerspectiveTitle);
    var filteredResults = pList.filter(function (p) {
      return p.getTitle().match(searchRegex);
    });

    // move exact match to the front
    var exactMatchIndex = filteredResults.findIndex(function (p) {
      return p.getTitle() == _this.newPerspectiveTitle && !p.hasMemberNode(_this.tag.id);
    });
    if (exactMatchIndex >= 0) {
      var p = filteredResults[exactMatchIndex];
      filteredResults.splice(exactMatchIndex, 1);
      filteredResults.unshift(p);
    }
    return filteredResults;
  }

  return pList;
};

this.getMatchingCardsInMap = function () {
  if (!_this.newPerspectiveTitle.length) {
    return [];
  }
  var nodes = _searchUi.searchUI.titleSearch(_this.newPerspectiveTitle);
  var currPerspectives = _this.getPerspectives();
  var filteredNodes = nodes.filter(function (n) {
    // filter out nodes that already have a perspective
    if (Boolean(currPerspectives.find(function (p) {
      return p.pointNodeUUID && p.pointNodeUUID == n.id || p.getTitle() == n.getTitle().toString();
    }))) {
      return false;
    }
    // filter out if the current map node is a point node
    if (_this.tag && _perspectivesUi.pui.getPerspectiveFromPointNode(_this.tag.id)) {
      return false;
    }
    return true;
  });

  if (!_this.hasExactPerspectiveMatch()) {
    // highlight exact match in cards in map results
    var exactMatchIndex = filteredNodes.findIndex(function (n) {
      return n.getTitle().toString() == _this.newPerspectiveTitle;
    });
    if (exactMatchIndex >= 0) {
      var node = filteredNodes[exactMatchIndex];
      filteredNodes.splice(exactMatchIndex, 1);
      filteredNodes.unshift(node);
    }
  }
  return filteredNodes;
};

this.setDefaultFocusedItem = function () {
  _this.focusedResult = null;
  if (!_this.newPerspectiveTitle || !_this.newPerspectiveTitle.length) {
    return;
  }
  if (_this.hasExactPerspectiveMatch()) {
    var perspective = _this.getExactPerspectiveMatch();
    _this.focusedResult = {
      type: 'perspective',
      perspective: perspective
    };
  } else if (_this.hasExactCardMatch()) {
    var node = _this.getExactCardMatch();
    _this.focusedResult = {
      type: 'node',
      node: node
    };
  } else {
    _this.focusedResult = {
      type: 'create'
    };
  }
};

this.summon = function (_ref) {
  var tag = _ref.tag,
      referenceEl = _ref.referenceEl,
      isBulkAction = _ref.isBulkAction,
      positionToLeft = _ref.positionToLeft,
      isLink = _ref.isLink,
      origin = _ref.origin;

  _this.hidden = false;
  _this.origin = origin;
  _this.parentRect = referenceEl.getBoundingClientRect();

  var _canvas$getMatrix = _this.canvas.getMatrix(),
      scale = _canvas$getMatrix.scale,
      tx = _canvas$getMatrix.tx,
      ty = _canvas$getMatrix.ty;

  _this.tag = tag;
  _this.type = null;
  if (tag && tag.instance) {
    if (tag.instance instanceof _store.Node) {
      _this.type = 'node';
    } else if (tag.instance instanceof _store.Link) {
      _this.type = 'link';
    }
  }
  if (isLink) {
    _this.shouldShowAnnotations = false;
  } else {
    _this.shouldShowAnnotations = true;
  }
  _this.isBulkAction = isBulkAction;
  _this.positionToLeft = positionToLeft;
  _this.isOpen = true;
  _this.update();
  _this.refs.main.classList.add('visible');
  _this.discoverSize();
  _this.repositionPanel();

  _this.finishSummoning();
};

this.fromOrigin = function (name) {
  return _this.origin === name;
};

this.getPanelItems = function () {
  if (_this.tags['node-perspectives-panel-item'] && _this.tags['node-perspectives-panel-item'].length) {
    return _this.tags['node-perspectives-panel-item'];
  } else {
    return [_this.tags['node-perspectives-panel-item']];
  }
  return [];
};

this.getPanelItem = function (perspectiveId) {
  return _this.getPanelItems().find(function (l) {
    return l.id == perspectiveId;
  });
};

this.discoverSize = function () {
  var menuRect = _this.refs.main.getBoundingClientRect();
  _this.width = menuRect.width;
  _this.height = menuRect.height;
};

this.repositionPanel = function () {
  _this.top = '';
  _this.left = '';
  _this.right = '';
  _this.bottom = '';

  if (_this.fromOrigin('toolbar')) {
    _this.top = _this.y = _this.parentRect.top + _this.parentRect.height + 1;
    _this.left = _this.parentRect.left - _this.width / 2 + _this.parentRect.width / 2;
    _this.refs.main.style.top = _this.top;
    _this.refs.main.style.left = _this.left;
    _this.refs.main.style.right = _this.right;
    _this.refs.main.style.bottom = _this.bottom;
    return;
  }

  if (_this.positionToLeft) {
    _this.y = _this.parentRect.top;
    _this.top = _this.y;
    _this.right = window.innerWidth - _this.parentRect.left;
  } else {
    _this.x = _this.parentRect.right;
    _this.y = _this.parentRect.top;
    _this.top = _this.y;
    _this.left = _this.x;
  }
  if (_this.height + _this.top > window.innerHeight) {
    _this.top = window.innerHeight - _this.height;
  }
  _this.refs.main.style.top = _this.top;
  _this.refs.main.style.left = _this.left;
  _this.refs.main.style.right = _this.right;
  _this.refs.main.style.bottom = _this.bottom;
};

this.scrollToEnd = function () {
  var el = _this.refs.scrollList;
  el.scrollTop = el.scrollHeight - el.clientHeight;
};

this.flashPerspective = function (perspective) {
  var pTag = _this.getPanelItems().find(function (t) {
    return t && t.perspective.id === perspective.id;
  });
  if (pTag) {
    pTag.refs.main.classList.add('active-notification');
    setTimeout(function () {
      pTag.refs.main.classList.remove('active-notification');
    }, 1000);
  }
};

this.finishSummoning = function () {
  _this.color = _perspectiveCreationUi.pcui.findNextUnusedColor();
  _this.update();

  _this.refs.newPerspectiveInput.focus();
};

this.pointNodeTitleAbbrev = function () {
  if (!_this.tag || !_this.tag.instance || _this.type != 'node') {
    return;
  }
  var node = _store_instance2.default.getNode(_this.tag.instance.id);
  if (!node) {
    return;
  }
  var title = node.title;
  if (!title) {
    return 'this card';
  }
  if (title.length > 20) {
    return title.substr(0, 20) + '...';
  }
  return title;
};

this.hide = function () {
  _perspectiveCreationUi.pcui.clearSelectedResultNode();
  _this.refs.main.classList.remove('visible');
  _this.hidden = true;
  _this.isOpen = false;
  _this.origin = null;
};
this.getStyle = function () {
  var strX = '';
  var strY = '';
  if (_this.right) {
    strX = 'right: ' + _this.right + 'px;';
  } else {
    strX = 'left: ' + _this.left + 'px;';
  }

  if (_this.bottom) {
    strY = 'bottom: ' + _this.bottom + 'px;';
  } else {
    strY = 'top: ' + _this.top + 'px;';
  }
  return strX + ' ' + strY;
};
this.nodeIsPerspectivePoint = function () {
  if (_this.tag && _this.type == 'node') {
    var perspective = _perspectivesUi.pui.getPerspectiveFromPointNode(_this.tag.id);
    if (perspective && !perspective.hidden) {
      return true;
    }
  }
  return false;
};

this.isChecked = function (perspective) {
  if (_this.isBulkAction) {
    var bulkStatus = _this.bulkMembershipStatus(perspective);
    if (bulkStatus == 'all-members') {
      // all selected items are in P
      return true;
    } else if (bulkStatus == 'some-members') {
      // some items in P
      return false;
    } else {
      // no items in P
      return false;
    }
  } else {
    if (_this.isMember(perspective)) {
      return true;
    } else {
      return false;
    }
  }
};

this.isMember = function (perspective) {
  if (_this.tag) {
    if (_this.type == 'node') {
      var nodesInPerspective = perspective.getMembers().nodes;
      return nodesInPerspective[_this.tag.id];
    } else if (_this.type == 'link') {
      var linksInPerspective = perspective.getMembers().links;
      return linksInPerspective[_this.tag.id];
    }
  }
};

this.bulkMembershipStatus = function (perspective) {
  var nodes = _this.canvas.getSelectedNodes();
  var links = _this.canvas.getSelectedLinks();
  var totalMembers = _this.getTotalSelectedElementsInPerspective(perspective);
  if (nodes.length + links.length == totalMembers) {
    // all selected items are in P
    return 'all-members';
  } else if (nodes.length + links.length > totalMembers && totalMembers > 0) {
    // some items in P
    return 'some-members';
  } else {
    // no items in P
    return 'no-members';
  }
};

this.handleBulkAction = function (perspective, operationMessages) {
  var bulkStatus = _this.bulkMembershipStatus(perspective);
  var nodes = _this.canvas.getSelectedNodes();
  var links = _this.canvas.getSelectedLinks();
  if (bulkStatus == 'all-members') {
    _perspectivesUi.pui.removeBatchFromPerspective({
      perspective: perspective,
      nodeTags: nodes.map(function (n) {
        return _this.canvas.nodeTags[n.id];
      }).filter(function (n) {
        return Boolean(n);
      }),
      linkTags: links.map(function (n) {
        return _this.canvas.linkTags[n.id];
      }).filter(function (l) {
        return Boolean(l);
      }),
      operationMessages: operationMessages
    });
  } else if (bulkStatus == 'some-members' || bulkStatus == 'no-members') {
    _perspectivesUi.pui.addBatchToPerspective({
      perspective: perspective,
      nodeTags: nodes.map(function (n) {
        return _this.canvas.nodeTags[n.id];
      }).filter(function (n) {
        return Boolean(n);
      }),
      linkTags: links.map(function (n) {
        return _this.canvas.linkTags[n.id];
      }).filter(function (l) {
        return Boolean(l);
      }),
      operationMessages: operationMessages
    });
  }
};

this.getTotalSelectedElementsInPerspective = function (perspective) {
  var nodesInPerspective = perspective.getMembers().nodes;
  var linksInPerspective = perspective.getMembers().links;
  var nodes = _this.canvas.getSelectedNodes();
  var links = _this.canvas.getSelectedLinks();
  var memberCount = 0;
  for (var _iterator = nodes, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref2;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref2 = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref2 = _i.value;
    }

    var node = _ref2;

    if (nodesInPerspective[node.id]) {
      memberCount++;
    }
  }
  for (var _iterator2 = links, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
    var _ref3;

    if (_isArray2) {
      if (_i2 >= _iterator2.length) break;
      _ref3 = _iterator2[_i2++];
    } else {
      _i2 = _iterator2.next();
      if (_i2.done) break;
      _ref3 = _i2.value;
    }

    var link = _ref3;

    if (linksInPerspective[link.id]) {
      memberCount++;
    }
  }
  return memberCount;
};

this.connectPerspectivePoint = function (e) {
  // if there's a perspective with the same title and it doesn't have a card...
  var perspective = _store_instance2.default.getPerspectiveFromTitleWithoutPointNode(_this.tag.instance.title);
  if (perspective && !perspective.pointNodeUUID) {
    _perspectivesUi.pui.editPerspectivePointNode({
      perspectiveUUID: perspective.id,
      pointNodeUUID: _this.tag.id
    });
    _this.tag.freshenEyeball();
    _perspectivesUi.pui.refreshPerspectiveLists();
  }
};

this.disconnectPerspectivePoint = function (e) {
  var perspective = _perspectivesUi.pui.getPerspectiveFromPointNode(_this.tag.id);
  _perspectivesUi.pui.editPerspectivePointNode({
    perspectiveUUID: perspective.id,
    pointNodeUUID: null
  });
  _this.tag.freshenEyeball();
  _perspectivesUi.pui.refreshPerspectiveLists();
};

this.togglePerspectivePoint = function (e) {
  e.stopPropagation();
  _perspectivesUi.pui.togglePerspectivePoint({
    nodeTag: _this.tag,
    color: _perspectiveCreationUi.pcui.findNextUnusedColor()
  });
};

this.showConnectPerspectiveButton = function () {
  if (_this.type == 'link' || _this.isBulkAction || !_this.tag) {
    return false;
  }
  if (!_this.nodeIsPerspectivePoint()) {

    // if there's a perspective with the same title and it doesn't have a card...
    var perspective = _store_instance2.default.getPerspectiveFromTitle(_this.tag.instance.title);
    if (perspective && !perspective.pointNodeUUID) {
      return true;
    }
  }
  return false;
};

this.connectedPerspectiveStyle = function () {
  if (!_this.tag || !_this.tag.instance) {
    return '';
  }
  var perspective = _store_instance2.default.getPerspectiveFromTitle(_this.tag.instance.title);
  if (perspective && !perspective.pointNodeUUID) {
    return 'color: ' + perspective.color + '; -webkit-text-stroke: 2px rgba(255,255,255,0.2);';
  }
  return '';
};

this.currentPerspectiveStyle = function () {
  if (!_this.tag || !_this.tag.instance) {
    return '';
  }
  var perspective = _perspectivesUi.pui.getPerspectiveFromPointNode(_this.tag.id);
  if (perspective) {
    return 'color: ' + perspective.color + '; -webkit-text-stroke: 2px rgba(255,255,255,0.2);';
  }
  return '';
};

this.openPerspectivesOnboarding = function () {
  _this.canvas.openSidebar('user-guide');
  _this.canvas.userGuideTag.openItem('what-is-p');
};

this.showMakePerspectiveButton = function () {
  if (_this.type == 'link' || _this.isBulkAction || !_this.tag) {
    return false;
  }
  if (!_this.nodeIsPerspectivePoint()) {
    // if there's a perspective with the same title and it doesn't have a card
    // return false since showConnectPerspectiveButton will return true
    var perspective = _store_instance2.default.getPerspectiveFromTitle(_this.tag.instance.title);
    if (perspective && !perspective.pointNodeUUID) {
      return false;
    }
    return true;
  }
  return false;
};

this.showRemovePerspectiveButton = function () {
  if (_this.type == 'link' || _this.isBulkAction || !_this.tag) {
    return false;
  }
  if (_this.nodeIsPerspectivePoint()) {
    return true;
  }
  return false;
};

this.handleInput = function (e) {
  if (_this.canvas.isViewOnly()) {
    return;
  }
  _this.newPerspectiveTitle = e.target.value.trim();
  var TAB = _constants.KEY_CODES.TAB,
      ESCAPE = _constants.KEY_CODES.ESCAPE;

  if (e.keyCode == TAB || e.keyCode == ESCAPE) {
    return;
  }
  if (!e.keyCode) {
    return;
  }
  _this.refreshCreateNewPerspectiveButtonVisibility();
  _this.refs.newPerspectiveCreateLabel.innerText = _this.newPerspectiveTitle;
  // regenerates perspective list filtered by latest input
  _this.update();
};

this.checkBlurKey = function (e) {
  var ESCAPE = _constants.KEY_CODES.ESCAPE,
      ENTER = _constants.KEY_CODES.ENTER;

  if (e.keyCode == ESCAPE) {
    e.preventDefault();
    //throw away changes;
    _this.clearInput();
  } else if (e.keyCode == ENTER) {

    _this.handleSubmitNewPerspective();
  }

  _perspectiveCreationUi.pcui.clearSelectedResultNode();
  _this.update();
};

this.handleSubmitNewPerspective = function (e) {
  if (e) e.preventDefault();
  var perspective = void 0;
  var operationMessages = [];
  if (_this.hasExactPerspectiveMatch()) {
    perspective = _this.getExactPerspectiveMatch();
    // add to existing perspective
  } else if (_this.hasExactCardMatch()) {
    var node = _this.getExactCardMatch();
    perspective = _perspectivesUi.pui.addPerspectivePoint({
      label: node.getTitle().toString(),
      color: _perspectiveCreationUi.pcui.findNextUnusedColor(),
      pointNodeUUID: node.id,
      operationMessages: operationMessages
    });
    // turn card into perspective point
  } else {
    perspective = _perspectivesUi.pui.addPerspectivePoint({
      label: _this.newPerspectiveTitle,
      color: _perspectiveCreationUi.pcui.findNextUnusedColor(),
      operationMessages: operationMessages
    });
  }
  if (!perspective) {
    console.error('error creating new perspective');
    return;
  }

  _this.clearInput();
  _this.handleAddAction(perspective, operationMessages);
};

this.handleCreateNewPerspective = function (e) {
  // clicking on Create new P button
  // if there's an exact match for P, use that,
  // otherwise create a new P w/out a card in map
  e.preventDefault();
  var perspective = void 0;
  var operationMessages = [];
  if (_this.hasExactPerspectiveMatch()) {
    perspective = _this.getExactPerspectiveMatch();
    // add to existing perspective
  } else {
    perspective = _perspectivesUi.pui.addPerspectivePoint({
      label: _this.newPerspectiveTitle,
      color: _perspectiveCreationUi.pcui.findNextUnusedColor(),
      operationMessages: operationMessages
    });
  }
  if (!perspective) {
    console.error('error creating new perspective');
    return;
  }
  _this.clearInput();
  _this.handleAddAction(perspective, operationMessages);
};

this.handleAddAction = function (perspective, operationMessages) {
  if (_this.tag || _this.isBulkAction) {
    var tag = _this.tag;
    if (_this.type == 'node') {
      _perspectivesUi.pui.addNodeToPerspective(perspective, tag, operationMessages);
    } else if (_this.type == 'link') {
      _perspectivesUi.pui.addLinkToPerspective(perspective, tag, operationMessages);
    } else if (_this.isBulkAction) {
      if (_this.handleBulkAction) {
        _this.handleBulkAction(perspective, operationMessages);
      }
    }
  }

  _this.operation.batchOperation({
    messages: operationMessages,
    onFailure: function onFailure(error) {
      console.log('makePerspective batchOperation failed, ' + error);
    }
  });

  _perspectiveCreationUi.pcui.clearSelectedResultNode();
  _perspectivesUi.pui.refreshPerspectiveLists();
};

this.handleCardInMapClick = function (nodeId) {
  var node = _this.canvas.store.getNode(nodeId);
  var operationMessages = [];
  var perspective = _perspectivesUi.pui.addPerspectivePoint({
    label: node.getTitle().toString(),
    color: _perspectiveCreationUi.pcui.findNextUnusedColor(),
    pointNodeUUID: node.id,
    operationMessages: operationMessages
  });
  _this.handleAddAction(perspective, operationMessages);
};

this.clearInput = function () {
  _this.newPerspectiveTitle = _this.refs.newPerspectiveInput.value = '';
  _this.refs.newPerspectiveCreateLabel.innerText = '';
  _this.focusedResult = null;
  _perspectiveCreationUi.pcui.clearSelectedResultNode();
  _this.refreshCreateNewPerspectiveButtonVisibility();
  _this.update();
};

// does the input match a node or perspective exactly?
this.getExactPerspectiveMatch = function () {
  if (!_this.tag) {
    return;
  }
  var perspectives = _this.getPerspectives();

  // try to get result that the node isn't in already
  var result = perspectives.find(function (p) {
    return p.getTitle() == _this.newPerspectiveTitle && !p.hasMemberNode(_this.tag.id);
  });
  if (!result) {
    // otherwise select the matching perspective (even if its already a member)
    result = perspectives.find(function (p) {
      return p.getTitle() == _this.newPerspectiveTitle;
    });
  }
  return result;
};
this.hasExactPerspectiveMatch = function () {
  return Boolean(_this.getExactPerspectiveMatch());
};
this.getExactCardMatch = function () {
  var nodes = _this.getMatchingCardsInMap();
  return nodes.find(function (p) {
    return p.getTitle() == _this.newPerspectiveTitle;
  });
};
this.hasExactCardMatch = function () {
  return Boolean(_this.getExactCardMatch());
};
this.hasExactMatch = function () {
  if (_this.hasExactPerspectiveMatch() || _this.hasExactCardMatch()) {
    return true;
  }
  return false;
};

this.refreshCreateNewPerspectiveButton = function () {
  if (_this.hasExactCardMatch()) {
    _this.enableCreateNewPerspectiveButton();
    _this.deselectCreateNewPerspectiveButton();
  } else if (_this.hasExactPerspectiveMatch()) {
    _this.disableCreateNewPerspectiveButton();
    _this.deselectCreateNewPerspectiveButton();
  } else {
    _this.enableCreateNewPerspectiveButton();
    _this.selectCreateNewPerspectiveButton();
  }
};

this.refreshCreateNewPerspectiveButtonVisibility = function () {
  // hide create button when there is no text in title input
  var createNewPerspectiveSection = _this.refs.createNewPerspectiveSection;

  if (!createNewPerspectiveSection) {
    return;
  }
  if (_this.newPerspectiveTitle && _this.newPerspectiveTitle.length) {
    _this.refs.createNewPerspectiveSection.style.display = '';
  } else {
    _this.refs.createNewPerspectiveSection.style.display = 'none';
  }
};

this.enableCreateNewPerspectiveButton = function () {
  var _refs = _this.refs,
      createNewPerspectiveRow = _refs.createNewPerspectiveRow,
      createNewPerspectiveSection = _refs.createNewPerspectiveSection;

  if (createNewPerspectiveRow) {
    createNewPerspectiveRow.classList.remove('disabled');
  }
  if (createNewPerspectiveSection) {
    createNewPerspectiveSection.classList.remove('disabled');
  }
};
this.disableCreateNewPerspectiveButton = function () {
  var _refs2 = _this.refs,
      createNewPerspectiveRow = _refs2.createNewPerspectiveRow,
      createNewPerspectiveSection = _refs2.createNewPerspectiveSection;

  if (createNewPerspectiveRow) {
    createNewPerspectiveRow.classList.add('disabled');
  }
  if (createNewPerspectiveSection) {
    createNewPerspectiveSection.classList.add('disabled');
  }
};
this.selectCreateNewPerspectiveButton = function () {
  var createNewPerspectiveRow = _this.refs.createNewPerspectiveRow;

  if (createNewPerspectiveRow) {
    createNewPerspectiveRow.classList.add('focused');
  }
};
this.deselectCreateNewPerspectiveButton = function () {
  var createNewPerspectiveRow = _this.refs.createNewPerspectiveRow;

  if (createNewPerspectiveRow) {
    createNewPerspectiveRow.classList.remove('focused');
  }
};

this.enboldenTitleSegment = function (element, text) {
  var innerText = element.innerText;
  var safeText = (0, _sharedUtil.escapeRegExp)(text);
  var replaceRegex = new RegExp(safeText, 'gi');
  // highlighted text appears in a separate transparent layer over the title and summary
  // with the marked text visible & highlighted
  innerText = innerText.replace(replaceRegex, "<mark>$&</mark>");
  if (element) {
    element.innerHTML = innerText;
  }
};

this.highlightDefaultResult = function () {
  _this.setDefaultFocusedItem();
  _this.highlightFocusedItem();
};

this.highlightFocusedItem = function () {
  $('.node-perspective-card-row.focused').removeClass('focused');
  $('node-perspectives-panel-item.focused').removeClass('focused');
  _this.deselectCreateNewPerspectiveButton();
  if (!_this.focusedResult) {
    return;
  }
  if (_this.focusedResult.type == 'perspective') {
    var panelItem = _this.getPanelItem(_this.focusedResult.perspective.id);
    panelItem.setFocusedStyle();
  } else if (_this.focusedResult.type == 'node') {
    var rowElement = document.querySelector('.node-perspective-card-row-' + _this.focusedResult.node.id);
    rowElement.classList.add('focused');
    _perspectiveCreationUi.pcui.highlightSelectedResultNode(_this.focusedResult.node);
  } else if (_this.focusedResult.type == 'create') {
    _this.selectCreateNewPerspectiveButton();
  }
};

this.highlightMatchingCardNames = function () {
  var cards = _this.getMatchingCardsInMap();
  if (cards.length && _this.newPerspectiveTitle.length) {
    for (var _iterator3 = cards, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
      var _ref4;

      if (_isArray3) {
        if (_i3 >= _iterator3.length) break;
        _ref4 = _iterator3[_i3++];
      } else {
        _i3 = _iterator3.next();
        if (_i3.done) break;
        _ref4 = _i3.value;
      }

      var node = _ref4;

      // render matching text in node title as bold
      var element = document.querySelector('.new-perspective-card-title-' + node.id);
      _this.enboldenTitleSegment(element, _this.newPerspectiveTitle);
    }
  }
};

this.ignoreDblClick = function (e) {
  e.stopPropagation();
  e.preventDefault();
};

this.handleSelectionMouseLeave = function (id, type, e) {
  if (type == 'node') {
    _perspectiveCreationUi.pcui.clearSelectedResultNode();
  }
};

this.handleSelectionMouseEnter = function (id, type, e) {
  if (type == 'node') {
    _perspectiveCreationUi.pcui.clearSelectedResultNode();
    _perspectiveCreationUi.pcui.highlightSelectedResultNode(_this.canvas.store.getNode(id));
  }
};

this.isEmptyList = function () {
  if (_this.getPerspectives().length || _this.newPerspectiveTitle) {
    return false;
  }
  return true;
};

this.handlePanelMouseEnter = function () {
  _delayHandler.delayHandler.clearDelayFor('submenus');
};

this.on('updated', function () {
  _this.highlightMatchingCardNames();
  _this.highlightDefaultResult();
  _this.refreshCreateNewPerspectiveButton();
});

this.on('mount', function () {
  $(_this.refs.main).on('mousedown touchstart pointerdown', function (e) {
    e.stopImmediatePropagation();
  });
});
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('node-perspectives-panel')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/node-perspectives-panel.html
// module id = 660
// module chunks = 0